import React from 'react'
import styled from 'styled-components'
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import Skeleton from '@ntuctech/devex-tangram/Skeleton'
import { SCREEN_SIZE, Media } from './../../lib/Media'
const ImageContainer = styled.div`
  display: flex;
`
const TilesVerContainer = styled.div`
  display: flex;
  flex-direction: column;
  > span {
    margin-bottom: 1rem;
  }
`
const TilesHorContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1.5rem;
  > span:not(:last-child) {
    margin-right: 1.25rem;
  }
`
const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  > span {
    margin-bottom: 0.25rem;
  }
  > span:first-child {
    margin-bottom: 0.5rem;
  }
`
const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  > span {
    margin-bottom: 0.375rem;
  }
`
const ProductDetailsPreviewContainer = styled.div`
  background: white;
  display: flex;
  padding: 6.625rem 3.5rem;
  flex-direction: column;
  flex: 1;
  > div:not(:last-child) {
    margin-bottom: 0.25rem;
  }

  ${SCREEN_SIZE.Only.Mobile} {
    margin-bottom: 5.5rem;
    padding: 3rem 0;
  }
  ${SCREEN_SIZE.Only.MobileL} {
    margin-bottom: 5.5rem;
  }
  ${SCREEN_SIZE.From.Tablet} {
    margin-bottom: 5.5rem;
    padding: 2.063rem 2rem;
  }
  ${SCREEN_SIZE.From.Desktop} {
    padding: 3.5rem 6.625rem;
    margin-bottom: 5.5rem;
  }
`
const ProductContent = styled.div`
  display: flex;
  ${SCREEN_SIZE.Only.Mobile} {
    margin-bottom: 5.5rem;
    flex-direction: column;
  }
  ${SCREEN_SIZE.Only.MobileL} {
    margin-bottom: 5.5rem;
    flex-direction: column;
  }
`
const ProductImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & > div:last-child {
    // margin-top: 1.5rem;
    ${SCREEN_SIZE.Only.Desktop} {
      display: none;
    }
  }
`
const ProductTiles = styled.div`
  display: flex;
  margin-left: 2rem;
  & span:first-child {
    margin-right: 9.125rem;
  }
  ${SCREEN_SIZE.Only.Mobile} {
    display: none;
  }
  ${SCREEN_SIZE.Only.MobileL} {
    display: none;
  }
`
const ProductDetails = styled.div`
  display: flex;
  margin-top: 0.5rem;
  ${SCREEN_SIZE.Only.Mobile} {
    margin-top: 1.5rem;
    padding-left: 1rem;
  }

  ${SCREEN_SIZE.Only.Tablet} {
    margin-top: 2rem;
  }
`
const ProductDescription = styled.div`
  > div {
    margin-top: 3.5rem;
    display: flex;
    & div:first-child {
      margin-right: 1rem;
    }
    ${SCREEN_SIZE.Only.Mobile} {
      flex-direction: column;
      padding-left: 1rem;
      margin-top: 3rem;
    }
    ${SCREEN_SIZE.Only.Tablet} {
      justify-content: start;
    }
    ${SCREEN_SIZE.From.Desktop} {
      margin-left: 16.375rem;
    }
  }
`
const loaderConfig = {
  productImage: [
    {
      variant: 'square',
      width: 320,
      height: 320,
      class: 'productImage',
    },
  ],
  productImageSmall: [
    {
      variant: 'square',
      width: 280,
      height: 280,
      class: 'productImage',
    },
  ],
  productTiles: [
    { variant: 'square', width: 56, height: 56, class: 'tiles' },
    { variant: 'square', width: 56, height: 56, class: 'tiles' },
    { variant: 'square', width: 56, height: 56, class: 'tiles' },
    { variant: 'square', width: 56, height: 56, class: 'tiles' },
  ],
  productDetails: [
    { variant: 'rectangle', width: 66, height: 32 },
    { variant: 'rectangle', width: 312, height: 24 },
    { variant: 'rectangle', width: 200, height: 24 },
    { variant: 'rectangle', width: 120, height: 16 },
  ],
  productDetailsMT: [
    { variant: 'rectangle', width: 66, height: 32 },
    { variant: 'rectangle', width: 328, height: 24 },
    { variant: 'rectangle', width: 200, height: 24 },
    { variant: 'rectangle', width: 120, height: 16 },
  ],
  productDescription: [
    {
      variant: 'rectangle',
      width: 160,
      height: 16,
    },
    {
      variant: 'rectangle',
      width: 320,
      height: 20,
    },
    {
      variant: 'rectangle',
      width: 320,
      height: 20,
    },
    {
      variant: 'rectangle',
      width: 260,
      height: 20,
    },
  ],
  productDescriptionMT: [
    {
      variant: 'rectangle',
      width: 160,
      height: 16,
    },
    {
      variant: 'rectangle',
      width: 320,
      height: 20,
    },
    {
      variant: 'rectangle',
      width: 260,
      height: 20,
    },
  ],
}

function ProductDetailsLoader({ type }) {
  const loader = (variant, width, height, key) => {
    return (
      <Skeleton key={key} variant={variant} width={width} height={height} />
    )
  }
  const loopPattern = (data, wrapper) => {
    const Component = wrapper
    return (
      <Component>
        {data.map((item, index) => {
          return loader(item.variant, item.width, item.height, index)
        })}
      </Component>
    )
  }

  const renderLoader = value => {
    const collection = {
      productImage: loopPattern(loaderConfig.productImage, ImageContainer),
      productImageSmall: loopPattern(
        loaderConfig.productImageSmall,
        ImageContainer
      ),
      productTile: loopPattern(loaderConfig.productTiles, TilesVerContainer),
      productTileHor: loopPattern(loaderConfig.productTiles, TilesHorContainer),
      productDetails: loopPattern(
        loaderConfig.productDetails,
        DetailsContainer
      ),
      productDetailsMT: loopPattern(
        loaderConfig.productDetailsMT,
        DetailsContainer
      ),
      productDescription: loopPattern(
        loaderConfig.productDescription,
        DescriptionContainer
      ),
      productDescriptionMT: loopPattern(
        loaderConfig.productDescriptionMT,
        DescriptionContainer
      ),
    }
    return collection[value]
  }

  const layout = () => {
    return (
      <ProductDetailsPreviewContainer data-testid="loader-container">
        <ProductContent>
          <ProductImage>
            <Media query={SCREEN_SIZE.Only.Mobile}>
              {renderLoader('productImageSmall')}
            </Media>
            <React.Fragment></React.Fragment>

            <Media query={SCREEN_SIZE.From.Tablet}>
              {renderLoader('productImage')}
            </Media>
            <React.Fragment></React.Fragment>

            <Media query={SCREEN_SIZE.Only.Tablet}>
              {renderLoader('productTileHor')}
            </Media>
          </ProductImage>

          <ProductTiles>
            <Media query={SCREEN_SIZE.From.Desktop}>
              {renderLoader('productTile')}
            </Media>
          </ProductTiles>

          <ProductDetails>
            <Media query={SCREEN_SIZE.Only.Mobile}>
              {renderLoader('productDetailsMT')}
            </Media>
            <Media query={SCREEN_SIZE.From.Tablet}>
              {renderLoader('productDetails')}
            </Media>
          </ProductDetails>
        </ProductContent>

        <ProductDescription>
          <Media query={SCREEN_SIZE.From.Desktop}>
            {renderLoader('productDescription')}
            {renderLoader('productDescription')}
          </Media>
          <Media query={SCREEN_SIZE.Only.Tablet}>
            {renderLoader('productDescriptionMT')}
            {renderLoader('productDescriptionMT')}
          </Media>
          <Media query={SCREEN_SIZE.Only.Mobile}>
            {renderLoader('productDescriptionMT')}
          </Media>
        </ProductDescription>
      </ProductDetailsPreviewContainer>
    )
  }

  return (
    <NdsThemeProvider>{type ? renderLoader(type) : layout()}</NdsThemeProvider>
  )
}
export default ProductDetailsLoader
